import { BaseRequest, IBaseRequest } from '../../BaseRequest';

export interface IListActivityTypeRequest extends IBaseRequest {
    fixedType?:       string;
    canBeRoot?:       string;
    systemType?:      string;
    categoryId?:      string;
    fpaTypeCategory?: string;
}

export class ListActivityTypeRequest extends BaseRequest implements IListActivityTypeRequest {
    fixedType?:       string;
    canBeRoot?:       string;
    systemType?:      string;
    categoryId?:      string;
    fpaTypeCategory?: string;

    constructor(server: string, session: string, otherOptions: any) {
        super(server, session);
        this.fixedType = otherOptions.fixedType;
        this.canBeRoot = otherOptions.canBeRoot;
        this.systemType = otherOptions.systemType;
        this.categoryId = otherOptions.categoryId;
        this.fpaTypeCategory = otherOptions.fpaTypeCategory
    }

    public toXml(): string {
        var parameters: string = super.toXml();

        parameters += this.makeNode(this.fixedType, 'fixedType');
        parameters += this.makeNode(this.canBeRoot, 'canBeRoot');
        parameters += this.makeNode(this.systemType, 'systemType');
        parameters += this.makeNode(this.categoryId, 'categoryId');
        parameters += this.makeNode(this.fpaTypeCategory, 'fpaTypeCategory');
        
        return super.wrapperXml('ListActivityType', parameters);
    }
}
